import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFarmLivestock } from "services";

import { DELETE_FARM_LIVESTOCK, GET_FARM_LIVESTOCK } from "consts";

export const useDeleteFarmLivestock = ({ farmId, year }: { farmId: string; year: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_FARM_LIVESTOCK, farmId],
    mutationFn: deleteFarmLivestock,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_LIVESTOCK, farmId, year] });
    },
  });
};
